import React from 'react';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';

const SortHeaderIcon = ({ order, orderBy, column }) => {
  if (orderBy === column) {
    if (order === 'ASC') return <ArrowUpward fontSize="inherit" />
    else return <ArrowDownward fontSize="inherit" />
  }
  return null;
}

export default SortHeaderIcon;


// WEBPACK FOOTER //
// ./src/commons/components/SortHeaderIcon.jsx